export function warning(text, additional, referralLink, vehicleDescription, vehicleValue) {
  return { type: 'warning', text, additional, referralLink, vehicleDescription, vehicleValue };
}
export function additionalInfoRequired(
  text,
  additional,
  referralLink,
  vehicleDescription,
  vehicleValue
) {
  return {
    type: 'additionalInfoRequired',
    text,
    additional,
    referralLink,
    vehicleDescription,
    vehicleValue
  };
}
export function formatError(text, additional, referralLink, vehicleDescription, vehicleValue) {
  return { type: 'format', text, additional, referralLink, vehicleDescription, vehicleValue };
}

export function logicError(text) {
  return { type: 'logic', text };
}

export function noError(text = '') {
  return { type: 'none', text };
}
